import { render, staticRenderFns } from "./EntitiesCrudPage.vue?vue&type=template&id=46d0c4eb"
import script from "./EntitiesCrudPage.vue?vue&type=script&lang=js"
export * from "./EntitiesCrudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports